export default __webpack_public_path__ + "ec5f5cbb4ac4a8cbeca2ebbef3b08ea9.png";